<template>
  <div>
    <SideButton path-to="/join">
      Есть работа!
    </SideButton>

    <HomeHero />

    <HomeTechnologies />

    <HomeNumbers :title="companyInfo.title" :items="companyInfo.items" />

    <HomeNumbers :title="programmingLanguages.title" :items="programmingLanguages.items" />

    <HomeJoin />

    <HomeCases/>
  </div>
</template>

<script>
import SideButton from 'components/BaseSideButton';

const HomeCases = () => import('./HomeCases.vue');
const HomeHero = () => import('components/HomeHero.vue');
const HomeTechnologies = () => import('components/HomeTechnologies.vue');
const HomeNumbers = () => import('components/HomeNumbers.vue');
const HomeJoin = () => import('components/HomeJoin.vue');
import { companyInfo, programmingLanguages } from 'data/mockHomeNumbers';

export default {
  name: 'Home',
  components: {
    SideButton,
    HomeCases,
    HomeHero,
    HomeTechnologies,
    HomeNumbers,
    HomeJoin,
  },
  data() {
    return {
      companyInfo,
      programmingLanguages,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Home.vue